import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';

import { Dominio } from 'src/app/model/dominio-operacao.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Injectable({ providedIn: 'root'})
export class DominiosResolver implements Resolve<Observable<Dominio>> {

    constructor(private dominiosService: DominiosService) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<Dominio>  {

       return this.dominiosService.getDadosDominio();
             
    }
}
